import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type AddPatientIconProps = SvgIconProps

export function AddPatientIcon(props: AddPatientIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Add_a_new_patient">
        <g>
          <g id="XMLID_00000140708516519583393150000008612300174651827075_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M135.78,103.799c23.8,0,43.1,19.3,43.1,43.1s-19.3,43.1-43.1,43.1
					c-20.31,0-37.34-14.05-41.9-32.96c-0.78-3.25-1.2-6.65-1.2-10.14c0-4.23,0.61-8.33,1.75-12.19c2.58-8.77,7.88-16.38,14.92-21.85
					C116.65,107.179,125.82,103.799,135.78,103.799z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M40.58,50.739c-1.43-2.94-2.82-7.34-1.85-12.35c1.28-6.65,5.96-10.58,8.98-13.12
					c4.04-3.39,8.13-5.07,10.78-5.93c-0.19-1.58-0.38-3.17-0.58-4.76c1.28,0.04,2.73,0.15,4.31,0.41c1.74,0.28,3.27,0.67,4.58,1.08
					c0.25-0.79,0.76-2.1,1.89-3.37c1.59-1.8,3.48-2.46,4.31-2.7c-0.12,0.6-0.36,2.22,0.41,4.04c0.73,1.74,1.95,2.69,2.47,3.04
					c3.2,1.84,5.71,3.65,7.5,5.05c2.53,1.98,5.26,4.16,7.42,7.31c1.61,2.35,2.5,4.69,2.61,4.96c0.49,1.25,0.66,2.01,0.66,2.01
					c0.42,2.13,0.89,6.06-0.42,10.62c-0.41,1.41-0.92,2.65-1.45,3.72c-0.52,1.04-1.05,1.92-1.54,2.64
					c-2.63-0.97-5.81-2.42-9.17-4.58c-2.67-1.72-4.86-3.51-6.6-5.12c-0.2,1.16-0.36,2.89-0.04,4.94c0.28,1.85,0.86,3.31,1.34,4.31
					c-3.05,0.2-10.07,0.24-17.51-3.77c-5.55-2.99-8.94-6.94-10.69-9.31c-1.05,1.5-2.23,3.49-3.22,5.95
					c-1.34,3.32-1.84,6.31-2.04,8.51C42.34,53.779,41.45,52.529,40.58,50.739z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M41.14,64.249c-0.43-2.15-3.22-1.32-4.44-6.39c-1.78-7.37,1.78-8.54,3.88-7.12c0.02,0.01,0.03,0.02,0.05,0.03"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M91.67,64.249c0.42-2.15,3.21-1.32,4.43-6.39c1.78-7.4-1.8-8.55-3.9-7.11c-0.01,0.01-0.02,0.01-0.03,0.02"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M41.14,64.249c2.37,15.75,12.78,27.61,25.26,27.61c12.49,0,22.9-11.86,25.27-27.61"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M73.58,61.629c0.31,0.25,1.43,1.06,3.06,1.01c1.48-0.03,2.49-0.75,2.82-1.01"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M59.22,61.629c-0.31,0.25-1.43,1.06-3.06,1.01c-1.48-0.03-2.49-0.75-2.82-1.01"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M71.97,81.579c-1.72-1.3-3.62-2.05-5.57-2.05c-1.94,0-3.84,0.75-5.57,2.05"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M92.2,50.749c0.53-1.07,1.04-2.31,1.45-3.72c1.31-4.56,0.84-8.49,0.42-10.62c0,0-0.17-0.76-0.66-2.01
					c-0.11-0.27-1-2.61-2.61-4.96c-2.16-3.15-4.89-5.33-7.42-7.31c-1.79-1.4-4.3-3.21-7.5-5.05c-0.52-0.35-1.74-1.3-2.47-3.04
					c-0.77-1.82-0.53-3.44-0.41-4.04c-0.83,0.24-2.72,0.9-4.31,2.7c-1.13,1.27-1.64,2.58-1.89,3.37c-1.31-0.41-2.84-0.8-4.58-1.08
					c-1.58-0.26-3.03-0.37-4.31-0.41c0.2,1.59,0.39,3.18,0.58,4.76c-2.65,0.86-6.74,2.54-10.78,5.93c-3.02,2.54-7.7,6.47-8.98,13.12
					c-0.97,5.01,0.42,9.41,1.85,12.35c0.87,1.79,1.76,3.04,2.15,3.58c0.2-2.2,0.7-5.19,2.04-8.51c0.99-2.46,2.17-4.45,3.22-5.95
					c1.75,2.37,5.14,6.32,10.69,9.31c7.44,4.01,14.46,3.97,17.51,3.77c-0.48-1-1.06-2.46-1.34-4.31c-0.32-2.05-0.16-3.78,0.04-4.94
					c1.74,1.61,3.93,3.4,6.6,5.12c3.36,2.16,6.54,3.61,9.17,4.58C91.15,52.669,91.68,51.789,92.2,50.749z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M61.98,160.299c0.02,0,0.04,0,0.07,0"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M47.9,93.679c-0.1,0.01-0.2,0.03-0.31,0.05c-0.07,0.02-0.15,0.03-0.23,0.05c-1.08,0.18-2.13,0.41-3.17,0.69
					c0,0-1.46,0.39-2.89,0.91c-11.14,4.01-16.4,13.8-16.4,13.8c-1.53,3.4-3.73,9.46-3.78,17.25v24.64c0,0,0,0,0.03,0
					c5.52,2.39,11.28,4.35,17.22,5.84c8.97,2.27,18.36,3.47,28.03,3.47c1.46,0,2.91-0.03,4.36-0.08c0.02,0,0.04,0,0.06,0
					c7.92-0.3,15.64-1.41,23.06-3.26"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M57.95,99.249c-1.51-0.43-2.97-1-4.35-1.7c-0.35-0.17-0.68-0.35-1.02-0.54c-0.34-0.18-0.67-0.38-1-0.58
					c-0.33-0.2-0.65-0.41-0.97-0.63c-0.63-0.42-1.25-0.88-1.84-1.37"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M60.51,99.839c-0.21-0.03-0.41-0.07-0.61-0.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M63.7,100.209c-0.25-0.01-0.5-0.03-0.75-0.05c-0.2-0.01-0.4-0.03-0.61-0.06"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M109.35,112.859c-0.49-1.44-1-2.68-1.45-3.68c0,0-5.26-9.79-16.4-13.8c-1.43-0.52-2.89-0.91-2.89-0.91
					c-1.04-0.28-2.09-0.51-3.17-0.69c-0.08-0.02-0.15-0.03-0.22-0.05c-0.11-0.02-0.22-0.04-0.32-0.05
					c-4.55,4.09-10.59,6.57-17.18,6.57h-0.3H66.4h-1.01h-0.3"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M47.9,93.679c0.28,0.25,0.58,0.5,0.87,0.75c0.59,0.48,1.21,0.94,1.84,1.37c0.32,0.22,0.65,0.42,0.97,0.63
					c0.33,0.2,0.66,0.39,1,0.58c0.34,0.19,0.68,0.37,1.02,0.54c1.39,0.69,2.84,1.26,4.35,1.7c0.64,0.18,1.29,0.34,1.95,0.47
					c0.2,0.05,0.4,0.09,0.61,0.12c0.6,0.11,1.21,0.2,1.83,0.26c0.2,0.03,0.41,0.05,0.61,0.06c0.25,0.02,0.5,0.04,0.75,0.05
					c0.46,0.03,0.92,0.04,1.39,0.04"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					65.39,100.259 48.94,108.679 47.6,93.759 				"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					67.42,100.259 83.86,108.679 85.21,93.759 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="66.4"
                y1="160.379"
                x2="66.4"
                y2="101.219"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					38.37,123.719 38.37,156.909 38.37,156.919 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="94.43"
                y1="134.709"
                x2="94.43"
                y2="123.719"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="94.43"
                y1="156.919"
                x2="94.43"
                y2="156.909"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M109.35,112.859
					c7.3-5.68,16.47-9.06,26.43-9.06c23.8,0,43.1,19.3,43.1,43.1s-19.3,43.1-43.1,43.1c-20.31,0-37.34-14.05-41.9-32.96
					c-0.78-3.25-1.2-6.65-1.2-10.14c0-4.23,0.61-8.33,1.75-12.19C97.01,125.939,102.31,118.329,109.35,112.859z"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="135.78,126.079 
					135.78,147.649 135.78,169.219 				"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="157.35,147.649 
					135.78,147.649 114.21,147.649 				"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default AddPatientIcon
